import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '../../widgets/widgets.module';
import { EffectsModule } from '@ngrx/effects';
import { ContactHeaderComponent } from '../contact-detail/contact-header.component';
import { ContactBodyComponent } from '../contact-detail/contact-body.component';

@NgModule({
    imports: [
        CommonModule,
        WidgetsModule
    ],
    declarations: [
        ContactBodyComponent,
        ContactHeaderComponent
    ],
    exports: [
        ContactBodyComponent,
        ContactHeaderComponent
    ],
    providers: [
    ]
})
export class ContactDetailModule {
}
